import {useDispatch, useSelector} from "react-redux";
import React from "react";
import ChipGroup, {ChipSecondary} from "../../../components/Chips";
import {setBlogTags} from "../../../redux/slices/manageBlogSlice";

export default function BlogTagList() {

  const dispatch = useDispatch();
  const tags = useSelector((state => state.manageBlogs.create.tags));
  const tagToBeAdded = useSelector((state => state.manageBlogs.create.tag.data));


  return (
    <>
      {(!!tags.length || tagToBeAdded) && <>
        <div className="text-sm mb-2">You can add up to 5 tags.</div>
        <ChipGroup>
          {tagToBeAdded && <ChipSecondary disabled={false} label={tagToBeAdded} loading={true}/>}

          {
            tags.map((tag) => <ChipSecondary disabled={false} label={tag.title} key={tag.id}
                                             onClose={() => dispatch(setBlogTags({remove: tag}))}/>)
          }

        </ChipGroup>
      </>}
    </>
  );
}




